import FeatureGrid from "@/components/base/FeatureGrid";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { patientAfter } from "@/mocks/patientInfo";

export default function PatientAfter() {
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="shell">
        <Reveal>
          <SectionHeading
            eyebrow="Çekim sonrası"
            title="İşlem bittiğinde ne oluyor?"
            description="Çekim sonrasında özel bir bakım gerekmez. Görüntü ve rapor, talep doğrultusunda diş hekiminize dijital olarak iletilir."
          />
        </Reveal>

        <div className="mt-14">
          <FeatureGrid items={patientAfter} columns={3} />
        </div>
      </div>
    </section>
  );
}